module.exports = global["jQuery"] = require("-!E:\\bamboo-home\\local-working-dir\\71106561-118423553\\irbDeploy\\WCG.IRB\\WCG.IRB.Api\\WCG.IRB.Api.IdentityService\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/dist/jquery.js-exposed
// module id = 0
// module chunks = 0 1